import React, { Suspense, useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';
import { AppContainer } from './layout/AppContainer';

function SplashScreen() {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#0f172a',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
      }}
    >
      <Box
        component="img"
        src="/logo.png"
        alt="Logo"
        onError={(e: any) => { e.target.style.display = 'none'; }}
        sx={{
          width: { xs: 150, md: 200 },
          mb: 4,
          animation: 'pulse 2s infinite ease-in-out',
          '@keyframes pulse': {
            '0%': { transform: 'scale(1)', opacity: 1 },
            '50%': { transform: 'scale(1.05)', opacity: 0.8 },
            '100%': { transform: 'scale(1)', opacity: 1 },
          },
        }}
      />
      <CircularProgress sx={{ color: '#A77B58' }} />
    </Box>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return <SplashScreen />;
  }

  return (
    <React.Fragment>
      <Suspense fallback={<SplashScreen />}>
        <HelmetProvider>
          <ToastContainer />
          <AppContainer />
        </HelmetProvider>
      </Suspense>
    </React.Fragment>
  );
}

export default App;
